<!-- src/components/TaxesForm.vue -->
<template>
  <div class="taxes-form">
    <div v-if="campaignMode" class="taxform-legend">
      <span class="taxform-legend__item">
        <i class="taxform-dot taxform-dot--custom"></i> Taxa personalizada da campanha
      </span>
      <span class="taxform-legend__item">
        <i class="taxform-dot taxform-dot--default"></i> Taxa padrão da plataforma
      </span>
    </div>
    <div class="box-main">
      <!-- PAGARME -->
      <div class="mb-5">
        <h3>PagarMe</h3>

        <div class="section">
          <!-- Parcelamento D+2 -->
          <div class="mt-4">
            <strong>Cartão de crédito parcelamento recebedor D+2</strong>

            <v-layout row wrap class="mt-2">
              <v-flex v-for="(item, index) in pagarme.parcelamentsD2" :key="`pg-d2-${item.parcelamentNumber}`" xs1 class="pb-2 pr-2">
                <InputMoney :autoFocusOnValidationFail="false"
                  :class="markerClass(item.taxPercentualValue, item.defaultValue)"
                  v-model="pagarme.parcelamentsD2[index].taxPercentualValue"
                  :textLabel="`${item.parcelamentNumber}x ${item.parcelamentNumber === 1 ? '(à vista)' : ''}`"
                  :precision="2" prefix="% " />
              </v-flex>
            </v-layout>
          </div>

          <!-- Parcelamento D+30 -->
          <div class="mt-4">
            <strong>Cartão de crédito parcelamento recebedor D+30</strong>

            <v-layout row wrap class="mt-2">
              <v-flex v-for="(item, index) in pagarme.parcelamentsD30" :key="`pg-d30-${item.parcelamentNumber}`" xs1 class="pb-2 pr-2">
                <InputMoney :autoFocusOnValidationFail="false"
                  :class="markerClass(item.taxPercentualValue, item.defaultValue)"
                  v-model="pagarme.parcelamentsD30[index].taxPercentualValue"
                  :textLabel="`${item.parcelamentNumber}x ${item.parcelamentNumber === 1 ? '(à vista)' : ''}`"
                  :precision="2" prefix="% " />
              </v-flex>
            </v-layout>
          </div>

          <!-- Boleto -->
          <v-layout row wrap class="mt-4">
            <v-flex xs2>
              <InputMoney v-model="pagarme.ticketTaxValue" textLabel="Taxa de transação via boleto" :precision="2"
                :class="markerClass(pagarme.ticketTaxValue, pagarme.ticketTaxValueDefault)"
                :autoFocusOnValidationFail="false" />
            </v-flex>
          </v-layout>

          <!-- Pix -->
          <v-layout row wrap class="mt-2">
            <v-flex xs2 class="pr-2">
              <InputMoney v-model="pagarme.pixTaxPercentualValue" textLabel="Taxa do Pix" :precision="2"
                :class="markerClass(pagarme.pixTaxPercentualValue, pagarme.pixTaxPercentualValueDefault)"
                :autoFocusOnValidationFail="false" prefix="% " />
            </v-flex>
            <v-flex xs2>
              <InputMoney v-model="pagarme.pixFixedValueLimit" textLabel="Limite fixo do Pix" :precision="2"
                :class="markerClass(pagarme.pixFixedValueLimit, pagarme.pixFixedValueLimitDefault)"
                :autoFocusOnValidationFail="false" prefix="R$ " />
            </v-flex>
          </v-layout>
        </div>
      </div>

      <v-divider class="my-4"></v-divider>

      <!-- ASAAS -->
      <div class="mb-5">
        <h3>ASAAS</h3>

        <div class="section">
          <!-- Parcelamento D+2 -->
          <div class="mt-4">
            <strong>Cartão de crédito parcelamento recebedor D+2</strong>

            <v-layout row wrap class="mt-2">
              <v-flex v-for="(item, index) in asaas.parcelamentsD2" :key="`as-d2-${item.parcelamentNumber}`" xs1 class="pb-2 pr-2">
                <InputMoney :autoFocusOnValidationFail="false"
                  :class="markerClass(item.taxPercentualValue, item.defaultValue)"
                  v-model="asaas.parcelamentsD2[index].taxPercentualValue"
                  :textLabel="`${item.parcelamentNumber}x ${item.parcelamentNumber === 1 ? '(à vista)' : ''}`"
                  :precision="2" prefix="% " />
              </v-flex>
            </v-layout>
          </div>

          <!-- Parcelamento D+30 -->
          <div class="mt-4">
            <strong>Cartão de crédito parcelamento recebedor D+30</strong>

            <v-layout row wrap class="mt-2">
              <v-flex v-for="(item, index) in asaas.parcelamentsD30" :key="`as-d30-${item.parcelamentNumber}`" xs1 class="pb-2 pr-2">
                <InputMoney :autoFocusOnValidationFail="false"
                  :class="markerClass(item.taxPercentualValue, item.defaultValue)"
                  v-model="asaas.parcelamentsD30[index].taxPercentualValue"
                  :textLabel="`${item.parcelamentNumber}x ${item.parcelamentNumber === 1 ? '(à vista)' : ''}`"
                  :precision="2" prefix="% " />
              </v-flex>
            </v-layout>
          </div>

          <!-- Boleto -->
          <v-layout row wrap class="mt-4">
            <v-flex xs2>
              <InputMoney v-model="asaas.ticketTaxValue" textLabel="Taxa de transação via boleto" :precision="2"
                :class="markerClass(asaas.ticketTaxValue, asaas.ticketTaxValueDefault)"
                :autoFocusOnValidationFail="false" />
            </v-flex>
          </v-layout>

          <!-- Pix -->
          <v-layout row wrap class="mt-2">
            <v-flex xs2 class="pr-2">
              <InputMoney v-model="asaas.pixTaxPercentualValue" textLabel="Taxa do Pix" :precision="2"
                :class="markerClass(asaas.pixTaxPercentualValue, asaas.pixTaxPercentualValueDefault)"
                :autoFocusOnValidationFail="false" prefix="% " />
            </v-flex>
            <v-flex xs2>
              <InputMoney v-model="asaas.pixFixedValueLimit" textLabel="Limite fixo do Pix" :precision="2"
                :class="markerClass(asaas.pixFixedValueLimit, asaas.pixFixedValueLimitDefault)"
                :autoFocusOnValidationFail="false" prefix="R$ " />
            </v-flex>
          </v-layout>
        </div>
      </div>

      <v-divider class="my-4"></v-divider>

      <!-- ITAÚ -->
      <div class="">
        <h3>Itaú</h3>

        <div class="section">
          <!-- Pix -->
          <v-layout row wrap class="mt-2">
            <v-flex xs6 class="pr-2">
              <InputMoney v-model="itau.pixTaxPercentualValue" textLabel="Taxa do Pix" :precision="2"
                :class="markerClass(itau.pixTaxPercentualValue, itau.pixTaxPercentualValueDefault)"
                :autoFocusOnValidationFail="false" prefix="% " />
            </v-flex>
            <v-flex xs6>
              <InputMoney v-model="itau.pixFixedValueLimit" textLabel="Limite fixo do Pix" :precision="2"
                :class="markerClass(itau.pixFixedValueLimit, itau.pixFixedValueLimitDefault)"
                :autoFocusOnValidationFail="false" prefix="R$ " />
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tax, { differsFromDefault } from "@/scripts/models/tax.model.js";
import PaymentMethodProvider from "@/scripts/models/enums/paymentMethodProvider.enum";

export default {
  name: "TaxForm",
  props: {
    // valores iniciais (opcionais), úteis quando editar
    initialAsaas: {
      type: Object,
      default: null,
    },
    initialPagarme: {
      type: Object,
      default: null,
    },
    initialItau: {
      type: Object,
      default: null,
    },
    defaultOnPlatform: {
      type: Boolean,
      default: false,
    },
    // quando true, exibe a marcacao visual (personalizada x padrao da plataforma)
    campaignMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      asaas: this.initialAsaas
        ? { ...this.initialAsaas }
        : new Tax(0, PaymentMethodProvider.Asaas, this.defaultOnPlatform),
      pagarme: this.initialPagarme
        ? { ...this.initialPagarme }
        : new Tax(0, PaymentMethodProvider.PagarMe, this.defaultOnPlatform),
      itau: this.initialItau
        ? { ...this.initialItau }
        : new Tax(0, PaymentMethodProvider.Itau, this.defaultOnPlatform),
    };
  },
  created() {
    // Se Itaú não usa parcelamento
    this.itau.parcelamentsD2 = [];
    this.itau.parcelamentsD30 = [];
  },
  methods: {
    getFormData() {
      return {
        asaas: this.asaas,
        pagarme: this.pagarme,
        itau: this.itau
      }
    },
    // Retorna a classe de marcacao do input: personalizado quando o valor difere
    // do padrao da plataforma; caso contrario, padrao. Atualiza ao vivo ao editar.
    markerClass(value, defaultValue) {
      if (!this.campaignMode) return "";
      return differsFromDefault(value, defaultValue)
        ? "taxform-field--custom"
        : "taxform-field--default";
    },
  },
  watch: {
    initialAsaas: {
      handler(newVal) {
        if (newVal) this.asaas = { ...newVal };
      },
      deep: true,
      immediate: true,
    },
    initialPagarme: {
      handler(newVal) {
        if (newVal) this.pagarme = { ...newVal };
      },
      deep: true,
      immediate: true,
    },
    initialItau: {
      handler(newVal) {
        if (newVal) this.itau = { ...newVal };
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<!-- nao-scoped: precisa alcancar o input interno do componente InputMoney -->
<style>
.taxes-form .taxform-legend {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  font-size: 12px;
  color: #7f8592;
}

.taxes-form .taxform-legend__item {
  display: inline-flex;
  align-items: center;
}

.taxes-form .taxform-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  margin-right: 6px;
}

.taxes-form .taxform-dot--custom {
  background: #fff6ec;
  border: 1px solid #f2994a;
}

.taxes-form .taxform-dot--default {
  background: transparent;
  border: 1px dashed #c7ccd8;
}

/* Taxa personalizada da campanha */
.taxform-field--custom .inside-input input {
  border: 1px solid #f2994a !important;
  background: #fff6ec !important;
}

/* Taxa padrao da plataforma (herdada) */
.taxform-field--default .inside-input input {
  border: 1px dashed #c7ccd8 !important;
  background: transparent;
}
</style>
